import { Injectable, inject, effect } from '@angular/core';
import { UsersService } from '@app/services/users.service';
import { ApiService } from '@app/services/api.service';

@Injectable({ providedIn: 'root' })
export class ProvidersService extends ApiService<any> {
    private readonly usersService = inject(UsersService);

    // @API providers
    protected serviceName = 'providers';

    constructor() {
        super();
        this.initConnection();

        effect(() => {
            if (this.usersService.authenticated()) {
                setTimeout(() => {
                    this.load();
                }, 100);
            }
        });
    }

    public getProviderById(id: string) {
        return this.items.find((x) => x._id === id);
    }

    public load(query?: any) {
        if (!this.isLoading) {
            this.isLoading = true;
            // @API providers.find
            this.find({
                query,
            })
                .then((data) => {
                    this.items = data;
                    this.itemsSubject.next(data);
                    this.itemsLoaded.next(true);
                    this.isLoading = false;
                })
                .catch(() => {
                    this.items = [];
                    this.itemsSubject.next([]);
                    this.itemsLoaded.next(false);
                    this.isLoading = false;
                });
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected _updated(item: any): void {
        this.load();
    }
}
